<template>
  <div
    class="c-avatar"
    :style="outerStyle"
  >
    <div
      v-if="src !== '' && src !== null"
      :style="imgWrapperStyle"
    >
      <img
        :src="src"
        :style="imgStyle"
      >
    </div>
    <div v-else>
      <div :style="initialWrapperStyle">
        <div
          :style="initialContentStyle"
        >
          <div>{{ initials }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CAvatar',
  props: {
    src: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '20px',
    },
  },
  computed: {
    initials() {
      return this.userName.slice(0, 1).toUpperCase();
    },
    initialWrapperStyle() {
      return {
        background: 'white',
        borderRadius: '100%',
        boxShadow: 'none',
      };
    },
    initialContentStyle() {
      return {
        boxSizing: 'content-box',
        border: '1px solid currentcolor',
        borderRadius: '100%',
        width: this.size,
        height: this.size,
        lineHeight: this.size,
        overflow: 'hidden',
        textAlign: 'center',
        fontSize: `${Math.round(parseInt(this.size, 10) / 2) + 2}px`,
        background: 'white',
        userSelect: 'none',
        color: this.$colors.grey.darken4,
        opacity: 1,
      };
    },
    imgWrapperStyle() {
      return {
        width: '100%',
        height: '100%',
      };
    },
    outerStyle() {
      if (this.src === '') {
        return {};
      }
      return {
        'border-radius': '100%',
        width: this.size,
        height: this.size,
        'max-width': '100%',
        'max-height': '100%',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'user-select': 'none',
        opacity: 1,
      };
    },
    imgStyle() {
      return {
        display: 'block',
        'object-fit': 'cover',
        'border-radius': '100%',
        width: '100%',
        height: '100%',
      };
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">

</style>
